import React from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "@egovernments/digit-ui-react-components";
import RevalidationSummary from "./RevalidationSummary";



function SearchSummary({ id, ref, handleDeclarationChange, declarationChecked, showDeclaration }) {
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const { data = {}, isLoading } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id, isEmployee }, { formType: "MAP_SUB" });
  if (isLoading) {
    return <Loader />
  } 
  return (
    <React.Fragment>
      {!isLoading && data && (
        <RevalidationSummary
          formData={data?.BPA?.[0]}
          ref={ref}
          handleDeclarationChange={handleDeclarationChange}
          declarationChecked={declarationChecked}
          showDeclaration={showDeclaration}
        />
      )}
    </React.Fragment>
  );
}

export default SearchSummary;
